export default __webpack_public_path__ + "static/media/pokebattle-desktop.9239dce3.jpg";